import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";

const axiosConfig: AxiosRequestConfig = {
  baseURL: process.env.REACT_APP_API_BASE_URL2,
  timeout: 15000,
};

const instance: AxiosInstance = axios.create(axiosConfig);
/* 
axios.interceptors.request.use(
  (config) => {
    return {
      ...config,
      headers: {
        Authorization: `Bearer ${JSON.parse(
          JSON.parse(localStorage.getItem("persist:root") || "").auth.data
            .accessToken
        )}`,
      },
    };
  },
  (error) => Promise.reject(error)
); */

class Request {
  async get(url: string): Promise<AxiosResponse> {
    return instance.get(url);
  }
  async post<T>(url: string, body: T): Promise<AxiosResponse> {
    return instance.post(url, body).then((res) => res.data);
  }
  async update(url: string, body: any): Promise<AxiosResponse> {
    return instance.patch(url, body).then((res) => res.data);
  }
  async delete(url: string): Promise<AxiosResponse> {
    return instance.delete(url).then((res) => res.data);
  }
}

const httpReq = new Request();

export default httpReq;
